import React from 'react';

const ComingSoon = () => (
  <div className="page page--center">
    <h1 className="coming-soon-text">Coming Soon</h1>
  </div>
);

export default ComingSoon;
